<template>
  <div>
    <template v-if="!isSearchingPosts">
      <div
        class="d-flex flex-column p-4 shadow-card fw700 font-black mb-4"
        v-if="
          showGetStarted &&
          (!authUser.user.no_of_members ||
            !authUser.user.first_post ||
            !authUser.user.url)
        "
      >
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fw700 font-black my-auto">
            Get started with <br class="show-in-mobile" />
            the essentials
          </h5>
          <a-icon
            @click="closeGetStarted"
            class="cp"
            type="close"
            :size="'large'"
          />
        </div>
        <p
          class="mt-3 d-flex align-items-center cp hoverbg p-1 br8"
          @click="() => $router.push({ name: 'MeetOthers' })"
          v-if="!authUser.user.no_of_members"
        >
          <img
            class="hw40 mr-2"
            src="../../assets/icons/user-plus-with-bg.png"
            alt="add members"
          />
          Add members to your circle
        </p>
        <p
          class="mt-3 d-flex align-items-center cp hoverbg p-1 br8"
          @click="showProfile"
          v-if="
            !authUser.user.url &&
            ['patient', 'caregiver', 'advocate'].includes(authUser.user.role)
          "
        >
          <img
            class="hw40 mr-2"
            src="../../assets/icons/image-with-bg.png"
            alt="add image"
          />
          Add profile image
        </p>
        <p
          class="mt-3 d-flex align-items-center cp hoverbg p-1 br8"
          @click="() => $refs.CreateNewPostModal.show()"
          v-if="!authUser.user.first_post"
        >
          <img
            class="hw40 mr-2"
            src="../../assets/icons/paper-plane-top-with-bg.png"
            alt="add post"
          />
          Create first post
        </p>
      </div>
      <div
        class="d-flex align-items-center p-4 br8 font-white mb-4 dovedaily-mobile"
        :style="{ 'background-color': getSecondaryColor() }"
        v-if="
          showUpdatePart &&
          (authUser.user.role === 'patient' ||
            authUser.user.role === 'caregiver') &&
          !isDateToday(new Date(dovedailyUpdatedAt)) &&
          authUser.user.tutorial_seen
        "
      >
        <div class="d-flex flex-grow-1 align-items-center">
          <!-- <img class="svg-icon-size mr-4" src="../../assets/icons/calendar-edit-solid.png" :style="{ 'background-size': 'contain' }" alt="calendar" /> -->
          <font-awesome-icon
            :icon="['fas', 'calendar-edit']"
            class="font20 font-white mr-4"
          />
          <div class="flex-grow-1 ml-2">
            <p class="mb-0 fw700 font-white">Update Your DoveDaily</p>
            <p v-if="dovedailyUpdatedAt" class="mb-0 font12 font-white">
              Last updated:
              {{ new Date(dovedailyUpdatedAt).toDateString().substring(4) }}
            </p>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div class="p-2 font12 fw700 cp" @click="notToday">Not Today</div>
          <div
            class="ml-4 br8 py-2 px-3 font12 fw700 cp hoverbg"
            :style="{ 'background-color': getPrimaryColor() }"
            @click="() => $router.push({ name: 'UpdateDoveDaily' })"
          >
            Add Update
          </div>
        </div>
      </div>
      <div class="shadow-card post-card d-flex flex-column mb-4 px-4">
        <p class="mb-3 font-black">
          Share something on
          <span class="fw700 text-capitalize">
            {{
              !currentCircle.condition_type.toLowerCase().includes("my")
                ? " My "
                : ""
            }}
            {{ currentCircle.condition_type || "" }}
            {{
              !currentCircle.condition_type.toLowerCase().includes("circle")
                ? " Circle"
                : ""
            }}
          </span>
        </p>
        <div class="d-flex">
          <div class="d-flex align-items-center">
            <a-avatar
              :style="{
                color: ' #ffffff !important',
                'background-color': authUser.user.url
                  ? ''
                  : getAvatarColor(authUser.user.id),
              }"
              :src="authUser.user ? authUser.user.url : ``"
              :size="40"
              class="text-capitalize font16 fw700 new-post-avatar cp"
              alt="avatar"
              @click="() => routeToAuthProfile(this.authUser.user.role)"
            >
              {{ getAuthUserInitials() }}
            </a-avatar>
          </div>
          <div
            class="create-post-popup"
            @click="() => $refs.CreateNewPostModal.show()"
          >
            <span class="create-post-popup--text">
              Post a message, poll or a question
            </span>
          </div>
        </div>
      </div>
      <div
        class="shadow-card d-flex py-3 px-4 justify-content-between align-items-center mb-4"
      >
        <p class="fw700 font-black text-capitalize">
          Showing {{ filteredMessage }}
        </p>
        <button
          type="submit"
          class="br8 p-2 hoverbg bg-gray100 position-relative"
          :style="{ border: 'none' }"
          @click="() => $refs.PostFilters.show()"
        >
          <img
            src="../../assets/icons/bars-filter-light.png"
            alt="filter"
            class="hw24"
          />
          <div
            v-if="filteredMessage !== 'All Activity'"
            class="active-filter-indicator"
            :style="{ background: getPrimaryColor() }"
          />
        </button>
      </div>
    </template>

    <div
      class="pinnedPost position-relative d-flex mb-4 rounded p-3"
      v-if="!isSearchingPosts && pinnedPost"
      style="box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1)"
    >
      <img
        v-if="pinnedPost.post_attach_url && pinnedPost.post_attach_url.length"
        :src="
          pinnedPost.post_attach_url[0].resized_images
            ? pinnedPost.post_attach_url[0].resized_images.dov1280x720
            : pinnedPost.post_attach_url[0].url
        "
        class="mr-3 h-100"
        style="width: 240px; object-fit: contain; align-self: center"
        alt="pinned post"
      />
      <div style="flex-grow: 1" class="d-flex flex-column">
        <p class="mb-2 fw700 gray900 font16" v-if="pinnedPost.post_title">
          {{ pinnedPost.post_title }}
        </p>
        <div
          v-if="!pinnedPost.sponsered.length"
          class="post-physician py-1 px-2 turquoise-text turquoise-bg font12 mb-2"
        >
          DoveMed Admin
        </div>
        <div
          v-else
          class="post-physician py-1 px-2 font12 mb-2"
          :style="{ color: getPrimaryColor(), background: getPrimary50Color() }"
        >
          Sponsored
        </div>
        <p
          v-if="pinnedPost.post_text"
          class="gray600 font16"
          v-html="pinnedPost.post_text"
        />
        <a
          :href="pinnedPost.link"
          target="_blank"
          class="fw700 font14 mt-auto"
          :style="{
            color: getPrimaryColor(),
            'text-decoration': 'none',
            'align-self': 'end',
          }"
        >
          {{ pinnedPost.link ? "More Info" : "" }}
        </a>
      </div>
      <font-awesome-icon
        :icon="['fal', 'times']"
        class="cp hw20 position-absolute ml-0"
        style="top: 16px; right: 16px"
        @click="removePinnedPost"
      />
    </div>

    <div
      class="welcomePost p-3 br8 mb-4"
      v-if="welcomePost && !isSearchingPosts"
      style="background: #f0fffa; box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1)"
    >
      <img
        v-if="welcomePost.post_attach_url && welcomePost.post_attach_url.length"
        :src="
          welcomePost.post_attach_url[0].resized_images
            ? welcomePost.post_attach_url[0].resized_images.dov1280x720
            : welcomePost.post_attach_url[0].url
        "
        class="mb-3 w-100"
        style="height: 360px; object-fit: contain"
        alt="welcome post"
      />
      <p class="mb-3 fw700 gray900 font16" v-if="welcomePost.post_title">
        {{ welcomePost.post_title }}
      </p>
      <p
        v-if="welcomePost.post_text"
        class="gray600 font16"
        v-html="welcomePost.post_text"
      />
    </div>

    <template v-if="isSearchingPosts">
      <!-- <SPeople :type="'People'" />
      <SPeople :type="'Advocates'" /> -->
    </template>

    <div
      v-if="isFetchingPost || activityPostsLoading"
      class="d-flex justify-content-center mb-4"
    >
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">
        Loading Posts...
      </div>
    </div>

    <div v-if="posts && posts.length" id="postsCon">
      <div v-for="post in posts" :key="post.id" class="eachPostContainer">
        <!-- <div v-for="(post, index) in posts" :key="post.id"> -->
        <div v-if="post.content_type === 'post'">
          <Post
            :postData="{ ...post, postId: post.id }"
            v-on:refresh="fetchPosts()"
            :fetchPosts="fetchPosts"
            :showFullScreen="showFullScreen"
            :handleOtherModals="handleOtherModals"
          />
        </div>

        <div v-else-if="post.content_type === 'job'">
          <Post
            :postData="{
              ...post.user_job,
              content_type: post.content_type,
              postId: post.id,
              sponsered: post.sponsered,
              user: [post.user_job.user],
              allow_comments: post.allow_comments,
              can_be_blurred: post.can_be_blurred,
            }"
            v-on:refresh="fetchPosts()"
            :fetchPosts="fetchPosts"
            :handleOtherModals="handleOtherModals"
          />
        </div>

        <div
          v-else-if="
            post.content_type === 'press' ||
            post.content_type === 'pressRelease'
          "
        >
          <Post
            :postData="{
              ...post.user_press,
              content_type: post.content_type,
              postId: post.id,
              sponsered: post.sponsered,
              user: [post.user_press.user],
              allow_comments: post.allow_comments,
              can_be_blurred: post.can_be_blurred,
            }"
            v-on:refresh="fetchPosts()"
            :fetchPosts="fetchPosts"
            :handleOtherModals="handleOtherModals"
          />
        </div>

        <div v-else-if="post.content_type === 'event'">
          <Post
            :postData="{
              ...post.user_event,
              content_type: post.content_type,
              postId: post.id,
              sponsered: post.sponsered,
              user: [post.user_event.user],
              allow_comments: post.allow_comments,
              can_be_blurred: post.can_be_blurred,
            }"
            v-on:refresh="fetchPosts()"
            :fetchPosts="fetchPosts"
            :handleOtherModals="handleOtherModals"
          />
        </div>

        <div v-else-if="post.content_type === 'poll'">
          <UserPoll
            v-if="post.user_poll"
            :pollData="{
              ...post.user_poll,
              postId: post.id,
              can_be_blurred: post.can_be_blurred,
            }"
            :fetchPosts="fetchPosts"
          />
        </div>

        <div v-else-if="post.content_type === 'question'">
          <QuestionCard
            :fetchPosts="fetchPosts"
            v-if="post.user_question"
            :quesData="{
              ...post.user_question,
              can_be_blurred: post.can_be_blurred,
            }"
            :showFullScreen="showFullScreen"
            :handleOtherModals="handleOtherModals"
          />
        </div>

        <!-- <div v-for="(poll, i) in pollData" :key="poll.id">
          <admin-card v-if="index + 1 === (i + 1) * 6 - 3" :pollData="poll" />
          <div class="mb-2 text-right cp" v-if="index + 1 === (i + 1) * 6 - 3" @click="$router.push(`/${currentCircle.condition_type}/home/resources/`)">
            <small :style="{ color: getPrimaryColor(), fontWeight: 'bold' }"> View All Polls </small>
          </div>
        </div> -->

        <!-- <div v-for="(trivia, i) in triviaData" :key="trivia.id">
          <TriviaCard v-if="index + 1 === (i + 1) * 6" :pollData="trivia" />
          <div class="mb-2 text-right cp" v-if="index + 1 === (i + 1) * 6" @click="$router.push(`/${currentCircle.condition_type}/home/resources/`)">
            <small :style="{ color: getPrimaryColor(), fontWeight: 'bold' }"> View All Trivia </small>
          </div>
        </div> -->
      </div>

      <!-- <div :style="{ 'text-align': 'center', 'margin-bottom': '18px' }">
          <a-button
            class="dovemed-button font-white primary-button"
            :style="{ background: getPrimaryColor() }"
            :loading="isFetchingPost"
            v-if="posts.length != pagination.total_count"
            @click="handleViewMorePosts"
          >
            View More
          </a-button>
        </div> -->

      <div
        v-if="isFetchingMorePost"
        class="d-flex justify-content-center my-3 flex-column align-items-center"
      >
        <div>
          <div class="spinner-border spinner-class"></div>
        </div>
      </div>
    </div>

    <div class="scrollTriggerContainer pb-3"></div>

    <div
      v-if="
        activityPostsLoading === false && isFetchingPost === false && !posts
      "
    >
      There are no posts found, do check after sometime.
    </div>

    <template v-if="isSearchingPosts">
      <!-- <SReview />
      <SResource />
      <STreatment /> -->
    </template>

    <CreateNewPostModal
      ref="CreateNewPostModal"
      :getPost="fetchPosts"
      :showCongrats="showCongrats"
      :handleOtherModals="handleOtherModals"
    />
    <createEvent ref="EventModal" :handleOtherModals="handleOtherModals" />
    <createJob ref="JobModal" :handleOtherModals="handleOtherModals" />
    <createPressRelease
      ref="PressModal"
      :handleOtherModals="handleOtherModals"
    />
    <post-filters :handleAnswer="handleSelectedFilters" ref="PostFilters" />
    <congrats :showInfoModal="showInfoModal" ref="Congrats" />
    <info
      ref="Info"
      v-if="
        authUser.user.role === 'patient' ||
        authUser.user.role === 'caregiver' ||
        authUser.user.role === 'advocate'
      "
    />
    <tutorial ref="tutorial" />
    <PostFullScreen ref="PostFullScreen" :postData="currentPostData" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Post from "./Post";
import AdminCard from "../home/poll/adminPollCard.vue";
import PollCard from "./resources/previews/PollCard";
import TriviaCard from "./resources/previews/TriviaCard";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import s3Upload from "../../utilities/imageUploader";
import EmojiPicker from "vue-emoji-picker";
import CustomEmojiPicker from "./emojiPicker";
import CreateNewPostModal from "../Modals/CreateNewPost.vue";
import createEvent from "../Modals/createEvent.vue";
import createJob from "../Modals/createJob.vue";
import createPressRelease from "../Modals/createPressRelease.vue";
import CreateMessageModal from "../Modals/CreateMessageModal.vue";
import moment from "moment";
import UserPoll from "../home/poll/UserPollCard.vue";
import QuestionCard from "../Users/Patient/QA/Question.vue";
import PostFilters from "../Modals/activity/PostFilters.vue";
import Congrats from "../Modals/activity/Congrats.vue";
import Info from "../Modals/activity/Info.vue";
import PostFullScreen from "../Modals/activity/PostFullScreen.vue";
import SPeople from "./search/SPeople.vue";
import SReview from "./search/SReview.vue";
import STreatment from "./search/STreatment.vue";
import SResource from "./search/SResource.vue";
import Tutorial from "../Modals/activity/Tutorial.vue";

const UserRepository = RepositoryFactory.get("user");
const PostRepository = RepositoryFactory.get("posts");
const ResourceRepository = RepositoryFactory.get("resource");

export default {
  name: "Activity",
  components: {
    Post,
    PollCard,
    TriviaCard,
    EmojiPicker,
    CustomEmojiPicker,
    CreateNewPostModal,
    createEvent,
    createJob,
    createPressRelease,
    moment,
    CreateMessageModal,
    UserPoll,
    QuestionCard,
    AdminCard,
    PostFilters,
    Congrats,
    Info,
    PostFullScreen,
    SResource,
    SReview,
    SPeople,
    STreatment,
    Tutorial,
  },

  data() {
    return {
      // emojiVisible: false,
      userPollData: [],
      pollData: [],
      triviaData: [],
      // showWritablePostArea: false,
      // writePost: { title: "", desc: "", day_type: "good", post_attach: [] },
      // filterPostBy: "",
      currentPage: 1,
      limit: 6,
      // showCommentSection: false,
      // inProgress: false,
      // filter: { all: true, healthcare_professional: false, my_circle_members: false, only_with_images: false },
      active: "all",
      appliedFilters: "",
      // previewVisible: false,
      // previewImage: "",
      // fileList: [],
      // showPicker: false,
      // search: "",
      // loading: false,
      isFetchingPost: false,
      isFetchingMorePost: false,
      // loc: { lat: null, lon: null },
      // postAndPollData: [],
      showGetStarted: false,
      showUpdatePart: false,
      filteredMessage: "All Activity",
      welcomePost: null,
      pinnedPost: null,
      dovedailyUpdatedAt: null,
    };
  },

  computed: {
    ...mapGetters({
      posts: "Posts/posts",
      pagination: "Posts/pagination",
      isSearchingPosts: "Posts/isSearchingPosts",
      activityPostsLoading: "Posts/activityPostsLoading",
    }),
  },

  // validations: {
  //   writePost: {
  //     title: {
  //       required: requiredIf(function () {
  //         return this.isDoctor();
  //       }),
  //     },
  //     desc: {
  //       required,
  //     },
  //     day_type: {
  //       required,
  //     },
  //   },
  // },

  async mounted() {
    console.warn("Activity.vue is MOUNTED");
    this.scrollTrigger();
    // this.handleInfinityScrollPosts()

    // const postsCon = document.querySelector("#postsCon")
    // postsCon.addEventListener("scroll", e => {
    //   if (postsCon.scrollTop + postsCon.clientHeight >= postsCon.scrollHeight) {
    //     this.handleViewMorePosts()
    //   }
    // })

    UserRepository.getUserDetails(
      this.authUser.user.id,
      this.currentCircle.id,
      this.authUser.user.role
    )
      .then((res) => {
        this.authUser.user.no_of_members = res.data.data[0].circle_member;
        if (
          this.authUser.user.no_of_members &&
          this.authUser.user.url &&
          this.authUser.user.first_post
        ) {
          this.showGetStarted = false;
        } else {
          this.showGetStarted = res.data.data[0].get_start;
        }
        if (
          res.data.data[0].not_today &&
          moment(res.data.data[0].not_today).dayOfYear() == moment().dayOfYear()
        ) {
          this.showUpdatePart = false;
        } else {
          this.showUpdatePart = true;
        }
      })
      .catch();

    // this.fetchPosts()
    this.handleSelectedFilters(
      this.$route.params.type === "all" ? "" : this.$route.params.type
    );
    // this.fetchResources()
    PostRepository.getPinnedPosts(this.currentCircle.id)
      .then((res) => {
        this.pinnedPost = res.data.data.data[0];
      })
      .catch((e) => {});

    if (
      this.authUser.user.role === "patient" ||
      this.authUser.user.role === "caregiver"
    ) {
      const response = await UserRepository.getDovedaily(this.currentCircle.id);
      this.dovedailyUpdatedAt =
        response.data.data[0] && response.data.data[0].last_updated_at;
    }

    // this.loc = await this.getLocation()
  },

  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },
  created() {
    console.warn("Activity.vue is created");
    // this.scrollTrigger()
    window.scrollTo(0, 0);
    if (!this.authUser.user.first_post) {
      PostRepository.getWelcomePosts(this.currentCircle.id)
        .then((res) => {
          this.welcomePost = res.data.data.data[0];
        })
        .catch((e) => {});
    }
  },

  methods: {
    async removePinnedPost() {
      try {
        // console.log("this.pinnedPost:", this.pinnedPost)
        await PostRepository.closePinnedPost({
          user: this.authUser.user.id,
          user_circle: this.currentCircle.id,
          user_role: this.authUser.user.role,
          pinned_post: this.pinnedPost.id,
        });
        this.pinnedPost = null;
      } catch (e) {
        console.log(e);
      }
    },
    scrollTrigger() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // console.log("entry.intersectionRatio:", entry.intersectionRatio)
          // console.log("this.posts:", this.posts)
          // console.log("this.pagination:", this.pagination)
          if (entry.intersectionRatio > 0) {
            // if (entry.intersectionRatio > 0 && this.posts && this.pagination && this.posts.length != this.pagination.total_count) {
            this.handleViewMorePosts();
          }
        });
      });
      observer.observe(this.$el.querySelector(".scrollTriggerContainer"));
    },
    async closeGetStarted() {
      this.showGetStarted = false;
      await UserRepository.editUserDetails(
        this.authUser.user.id,
        this.currentCircle.id,
        this.authUser.user.role,
        { get_start: false }
      );
      this.$notification.success({
        message: "Closed",
        description: "Get Started options won't be shown again.",
      });
    },
    async notToday() {
      this.showUpdatePart = false;
      await UserRepository.editUserDetails(
        this.authUser.user.id,
        this.currentCircle.id,
        this.authUser.user.role,
        { not_today: new Date() }
      );
      this.$notification.success({
        message: "Done",
        description: "Update DoveDaily prompt won't be shown for today.",
      });
    },
    showFullScreen(d) {
      this.$refs.PostFullScreen.show(d);
    },
    handleOtherModals(
      modalToOpen,
      data = null,
      type = "post",
      editing = false,
      tags = [],
      id
    ) {
      switch (modalToOpen) {
        case "pressRelease":
        case "press":
          this.$refs.PressModal.show(data, editing, tags, id);
          break;
        case "job":
          this.$refs.JobModal.show(data, editing, tags, id);
          break;
        case "event":
          this.$refs.EventModal.show(data, editing, tags, id);
          break;
        case "add":
        case "new":
        case "edit":
          this.$refs.CreateNewPostModal.show(
            editing ? "edit" : "add",
            data,
            type,
            tags,
            id
          );
          break;
        case "more":
        case "back":
        case "moreOptions":
          this.$refs.CreateNewPostModal.show("more", data, type, tags, id);
          break;
      }
    },
    showInfoModal() {
      if (
        this.authUser.user.role === "patient" ||
        this.authUser.user.role === "caregiver" ||
        this.authUser.user.role === "advocate"
      ) {
        this.$refs.Info.show();
      }
    },
    showCongrats() {
      this.$refs.Congrats.show();
    },
    handleSelectedFilters(ans) {
      // console.log("from filter modal ans:", ans)
      this.appliedFilters = ans;
      this.fetchPosts(false);
      if (ans) {
        // console.log("1 - ans:", ans)
        ans =
          ans.split(",")[0].split("_").join(" ") +
          (ans.split(",")[1] ? "," + ans.split(",")[1] : "");
        // console.log("2 - ans:", ans)

        this.filteredMessage = ans.split(",").reverse().join("s from ") + "s";
        // console.log("filteredMessage:", this.filteredMessage)

        if (this.filteredMessage.includes("admin")) {
          this.filteredMessage = this.filteredMessage.replace(
            "admin",
            "DoveMed Admin"
          );
        }
        if (this.filteredMessage.includes("imagess")) {
          this.filteredMessage = this.filteredMessage.replace(
            "imagess",
            "Images"
          );
        }
        if (this.filteredMessage.includes("memberss")) {
          this.filteredMessage = this.filteredMessage.replace(
            "memberss",
            "members"
          );
        }
        if (this.filteredMessage.includes("presss")) {
          this.filteredMessage = this.filteredMessage.replace(
            "presss",
            "Press Releases"
          );
        }
      } else {
        this.filteredMessage = "All Activity";
      }
    },
    // handleEmojiVisible() {
    //   this.emojiVisible = !this.emojiVisible
    // },
    // insert(emoji) {
    //   this.writePost.desc += emoji
    // },
    // handleCancel() {
    //   this.previewVisible = false
    // },
    // handlePreview(file) {
    //   this.previewImage = file.url || file.thumbUrl
    //   this.previewVisible = true
    // },

    /**
     * Fetch all posts of the user
     *
     */
    fetchResources() {
      ResourceRepository.getResourceListByType(
        "Polls",
        1,
        10,
        this.currentCircle.id
      )
        .then((res) => {
          this.pollData = res.data.data;
        })
        .catch((err) => {});
      ResourceRepository.getResourceListByType(
        "Trivia",
        1,
        10,
        this.currentCircle.id
      )
        .then((res) => {
          this.triviaData = res.data.data;
        })
        .catch((err) => {});
    },

    handleInfinityScrollPosts() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight ===
          document.documentElement.offsetHeight;
        console.log({ bottomOfWindow });
        if (bottomOfWindow) {
          this.handleViewMorePosts();
        }
      };
    },

    fetchPosts(append = false, page = 1) {
      console.warn("Activity - fetchPosts()");
      this.$store.commit("Posts/setPosts", { data: [] });
      this.isFetchingPost = true;
      this.$store.commit("App/setLoading", true);
      PostRepository.getAll(
        this.authUser.user.id,
        this.currentCircle.id,
        page ? page : this.currentPage,
        this.limit,
        this.appliedFilters,
        this.$store.state.Posts.filterPostKey
      )
        .then((res) => {
          this.$store.commit("Posts/setPosts", res.data);
          this.$store.commit("App/setLoading", false);
          this.isFetchingPost = false;
          // const postsContainer = this.$el.querySelector(".postsContainer")
          // if (postsContainer) {
          //   useInfiniteScroll(
          //     postsContainer,
          //     () => {
          //       this.handleViewMorePosts()
          //     },
          //     { distance: 10 }
          //   )
          // }
          this.scrollTrigger();
        })
        .catch((err) => {
          this.$store.commit("App/setLoading", false);
          this.isFetchingPost = false;
        });
    },

    // filterPosts(e) {
    //   this.currentPage = 1;
    //   this.filter[this.active] = false;
    //   this.filter[e.target.id] = true;
    //   this.active = e.target.id;
    //   this.makeFilters();
    //   /* #endregion */
    // },
    // filterOnlyWithImages(e) {
    //   this.currentPage = 1;
    //   this.filter.only_with_images = e.target.checked;
    //   this.makeFilters();
    // },
    // makeFilters() {
    //   const filters = Object.keys(this.filter).filter(
    //     key => key !== "all" && this.filter[key]
    //   );
    //   this.appliedFilters = filters.join(",");
    //   this.fetchPosts(false);
    // },

    /**
     * Save post
     *
     */
    // savePost() {
    //   this.inProgress = true
    //   this.loading = true
    //   this.$v.$touch()
    //   const payload = {
    //     user_circle: this.currentCircle.id,
    //     user: this.authUser.user.id,
    //     day_type: this.writePost.day_type,
    //     receiver_user: null,
    //     post_attach: this.writePost.post_attach.length > 0 ? this.writePost.post_attach : null,
    //     latlong: { lat: this.loc.lat, lon: this.loc.lon },
    //     post_text: this.writePost.desc,
    //     post_title: this.writePost.title,
    //     post_time: new Date().toISOString(),
    //   }
    //   if (!this.$v.$anyError) {
    //     PostRepository.createPost(payload)
    //       .then(res => {
    //         this.showWritablePostArea = false
    //         this.inProgress = false
    //         this.writePost.title = ""
    //         this.writePost.desc = ""
    //         this.$v.$reset()
    //         this.currentPage = 1
    //         this.fetchPosts()
    //         this.fileList = []
    //         this.writePost.post_attach = []
    //         this.loading = false
    //         this.$notification.success({
    //           message: "Success",
    //           description: "Post Created successfully.",
    //         })
    //       })
    //       .catch(err => {
    //         this.loading = false
    //       })
    //   } else {
    //     this.loading = false
    //   }
    // },

    /**
     * Get the location of the user using Geolocation
     */
    // getLocation() {
    //   return new Promise(function (resolve, reject) {
    //     navigator.geolocation.getCurrentPosition(pos => {
    //       const lat = pos.coords.latitude
    //       const lon = pos.coords.longitude
    //       resolve({ lat, lon })
    //     })
    //   })
    // },

    handleViewMorePosts() {
      if (
        this.isFetchingPost ||
        this.isFetchingMorePost ||
        !this.posts ||
        (this.posts && !this.posts.length)
      ) {
        // console.log("returned")
        // console.log("this.isFetchingPost: ", this.isFetchingPost)
        // console.log("this.isFetchingMorePost: ", this.isFetchingMorePost)
        // console.log("this.posts: ", this.posts)
        return;
      }
      this.currentPage += 1;
      this.isFetchingMorePost = true;
      PostRepository.getAll(
        this.authUser.user.id,
        this.currentCircle.id,
        this.currentPage,
        this.limit,
        this.appliedFilters,
        this.$store.state.Posts.filterPostKey
      )
        .then((res) => {
          this.$store.commit("Posts/viewMorePosts", res.data);
          this.isFetchingMorePost = false;
        })
        .catch((err) => {
          this.isFetchingMorePost = false;
        });
    },

    showProfile() {
      const profileType = this.authUser.user.role;

      switch (profileType) {
        case "patient":
          this.$router.push({ name: "PatientUpdates" });
          break;
        case "caregiver":
          this.$router.push({ name: "CaregiverUpdates" });
          break;
        case "advocate":
          this.$router.push({ name: "AdvocateUpdates" });
          break;
        case "hospital_administrator":
          this.$router.push({ name: "HosUpdates" });
          break;
        case "clinic_administrator":
          this.$router.push({ name: "ClinicUpdates" });
          break;
        case "doctor":
          this.$router.push({ name: "DocUpdates" });
          break;
        case "hcp":
          this.$router.push({ name: "HcpAbout" });
          break;
        case "nfp_administrator":
          this.$router.push({ name: "NFPAbout" });
          break;
        case "clinic_profile":
          this.$router.push({ name: "Clinic_Profile" });
          break;
        default:
          this.$router.push({ path: `profile/${profileType}/updates` });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-avatar-string {
  transform: scale(1) translate(-50%) !important;
}
.hoverbg:hover {
  background-color: rgba(10, 10, 10, 0.1) !important;
}
.active-filter-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  align-self: flex-start;
  top: 0;
  right: 0;
  position: absolute;
  margin-top: 5px;
  margin-right: 5px;
}
.font-black {
  color: #000000 !important;
  * {
    color: #000000 !important;
  }
}
// .dovemed-card {
//   padding: 20px;
//   background: #fff;
//   border-radius: 8px;
//   border: 1px solid #ccc;
//   margin-bottom: 20px;

//   .title {
//     font-size: 18px;
//     font-weight: bold;
//   }

//   .sub-title {
//     font-size: 16px;
//     font-weight: 500;
//   }
// }
// .create-post-container {
//   .post-radio-group {
//     .buttn {
//       background: pink;
//     }

//     .ant-radio-button-wrapper {
//       border-radius: 18px;
//       margin-left: 20px;

//       &::before {
//         display: none;
//       }
//     }
//   }

//   .title-input {
//     display: block;
//     margin-bottom: 20px;
//     border: 1px solid #e2e2e2;
//     background: #f7f7f7;
//     padding: 10px 30px;

//     &:focus {
//       box-shadow: 0 0 transparent;
//     }
//   }

//   .message-input-container {
//     display: block;
//     border: 1px solid #e2e2e2;
//     background: #f7f7f7;
//     border-radius: 10px;
//     padding: 10px 20px;

//     textarea {
//       border: transparent;
//       border-radius: 0;
//       border-bottom: 1px solid #e2e2e2;

//       &:focus {
//         box-shadow: 0 0 transparent;
//       }
//     }

//     .button-container {
//       padding: 5px 0 0 0;
//       text-align: right;
//       display: flex;
//       justify-content: flex-end;
//       align-items: center;
//       height: 40px;

//       input {
//         height: 25px;
//       }
//     }
//   }
// }

// .post-radio-group {
//   display: flex;
//   .post-radio {
//     width: 100px;
//     height: 32px;
//     text-align: center;
//     border-radius: 32px;
//     margin-left: 16px;
//     @media screen and (max-width: 600px) {
//       margin: 15px 10px 15px 0;
//       width: 24vw;
//       height: 28px;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//   }
// }

// .filter-options {
//   display: flex;
//   justify-content: space-between;

//   @media screen and (max-width: 900px) {
//     flex-direction: column;
//   }

//   .filter-by {
//     color: #333333;
//     font-family: Lato;
//     font-size: 14px;
//     font-weight: bold;
//     letter-spacing: 0;
//     line-height: 22px;
//     &::after {
//       content: "";
//       margin-left: 0;
//     }
//   }

//   span {
//     margin-left: 5px;
//     font-family: Lato;
//     font-size: 12px;
//     font-weight: 900;
//     letter-spacing: 0;
//     line-height: 22px;

//     &::after {
//       color: black;
//       content: "|";
//       margin-left: 5px;
//     }

//     &:last-child:after {
//       content: "";
//       margin-left: 0px;
//     }
//   }
// }

// .fa-camera {
//   width: 35px;
//   height: 35px;
//   position: relative;
//   vertical-align: text-top;
//   cursor: pointer;
// }
// .camera-icon-inp {
//   opacity: 0;
//   position: absolute;
//   left: 0;
//   top: 0;
//   width: 100%;
//   height: 40px;
//   cursor: pointer;
// }

// .wrapper {
//   position: relative;
//   display: inline-block;
// }

// .post-button {
//   box-sizing: border-box;
//   height: 35px !important ;
//   width: 115px;
//   color: white;
//   border: none;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-family: Lato;
//   font-size: 16px;
//   font-weight: bold;
//   letter-spacing: 0;
//   border-radius: 27px;
//   margin-left: 5px;
//   margin-right: 16px;
// }

.post-card {
  @media screen and (min-width: 800px) {
    padding-right: 40px;
  }
}

@media screen and (max-width: 600px) {
  .p-4,
  .shadow-card {
    border-radius: 0 !important;
  }
  .dovedaily-mobile {
    flex-direction: column;
    align-items: flex-start !important;
  }
  .dovedaily-mobile > div:nth-child(2) {
    margin-left: auto;
    margin-top: 16px;
  }
  .dovemed-wrapper {
    // max-width: 90%;
    max-width: 100% !important;
  }
  .pinnedPost {
    flex-direction: column;
    img {
      margin-bottom: 16px;
    }
  }
}
.show-in-mobile {
  display: none !important;
  @media screen and (max-width: 900px) {
    display: flex !important;
  }
}
// .regular-input {
//   padding: 0.5rem 1rem;
//   border-radius: 3px;
//   border: 1px solid #ccc;
//   width: 20rem;
//   height: 12rem;
//   outline: none;
// }

// .regular-input:focus {
//   box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
// }

// .emoji-invoker {
//   position: relative;
//   font-size: 20px;
//   border-radius: 50%;
//   cursor: pointer;
//   transition: all 0.2s;
// }
// .emoji-invoker:hover {
//   transform: scale(1.1);
// }
// .emoji-invoker > svg {
//   fill: #b1c6d0;
// }

// .emoji-picker {
//   position: absolute;
//   z-index: 8;
//   font-family: Montserrat;
//   border: 1px solid #ccc;
//   height: 20rem;
//   overflow: auto;
//   padding: 1rem;
//   box-sizing: border-box;
//   border-radius: 0.5rem;
//   background: #fff;
//   box-shadow: 1px 1px 8px #c7dbe6;
//   margin-left: -60px;
// }
// .emoji-picker__search {
//   display: flex;
// }
// .emoji-picker__search > input {
//   flex: 1;
//   border-radius: 10rem;
//   border: 1px solid #ccc;
//   padding: 0.5rem 1rem;
//   outline: none;
// }
// .emoji-picker h5 {
//   margin-bottom: 0;
//   margin-top: 10px;
//   font-weight: bold;
//   color: #b1b1b1;
//   text-transform: uppercase;
//   font-size: 0.8rem;
//   cursor: default;
// }
// .emoji-picker .emojis {
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: space-between;
// }
// .emoji-picker .emojis:after {
//   content: "";
//   flex: auto;
// }
// .emoji-picker .emojis span {
//   padding: 0.2rem;
//   cursor: pointer;
//   border-radius: 5px;
// }
// .emoji-picker .emojis span:hover {
//   background: #ececec;
//   cursor: pointer;
// }
// .flexing {
//   display: flex;
//   justify-content: space-between;
//   flex-wrap: wrap;
//   height: auto;
// }
// .check-box {
//   transform: scale(1.3);
//   margin-right: 5px;
//   cursor: pointer;
// }
// .file-images {
//   display: flex;
//   padding: 10px;
//   position: relative;
//   .ico-cancel {
//     position: absolute;
//     font-size: 20px;
//     color: red !important;
//     top: 0;
//     right: 0;
//   }
// }
.create-post-popup {
  cursor: pointer;
  height: 40px;
  width: 100%;
  background-color: rgba(122, 140, 163, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  align-self: center;
  margin-left: 10px;

  &--text {
    margin-left: 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
    color: #7a8ca3;
  }
}
// .loader-bg {
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background: rgba(0, 0, 0, 0.6);
//   .loader-container {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     .lds-ring {
//       display: inline-block;
//       position: relative;
//       width: 80px;
//       height: 80px;
//     }
//     .lds-ring div {
//       box-sizing: border-box;
//       display: block;
//       position: absolute;
//       width: 64px;
//       height: 64px;
//       margin: 8px;
//       border: 8px solid #fff;
//       border-radius: 50%;
//       animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
//       border-color: #fff transparent transparent transparent;
//     }
//     .lds-ring div:nth-child(1) {
//       animation-delay: -0.45s;
//     }
//     .lds-ring div:nth-child(2) {
//       animation-delay: -0.3s;
//     }
//     .lds-ring div:nth-child(3) {
//       animation-delay: -0.15s;
//     }
//     @keyframes lds-ring {
//       0% {
//         transform: rotate(0deg);
//       }
//       100% {
//         transform: rotate(360deg);
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/home/Activity.vue